import { defineSlotRecipe } from '@chakra-ui/react';
import { selectAnatomy } from '@chakra-ui/react/anatomy';

export const selectSlotRecipe = defineSlotRecipe({
  slots: selectAnatomy.keys(),
  base: {
    trigger: {
      borderRadius: 'l1',
    },
    content: {
      borderRadius: 'l1',
    },
  },
  variants: {
    size: {
      md: {
        root: {
          '--select-trigger-height': 'sizes.8',
          '--select-trigger-padding-x': 'spacing.2',
        },
      },
    },
    variant: {
      outline: {
        trigger: {
          borderColor: '{colors.neutral.100}',
          _expanded: {
            borderColor: '{colors.brand.500}',
          },
        },
      },
    },
  },
});
